import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useMemo } from 'react';
import { useWindowSize } from '@magento/peregrine/lib/hooks/useWindowSize';
import { useUserContext } from '@magento/peregrine/lib/context/user/';
import { DownloadResourceIcon, PdfIcon, DocIcon, RevitIcon, CadIcon, ImageFileIcon } from '/src/components';
import defaultClasses from './resourcesContent.module.css';

var ResourcesDocumentItem = function ResourcesDocumentItem(_ref) {
  var _item$file_format, _item$customer_price_;

  var item = _ref.item;

  var _useUserContext = useUserContext(),
      _useUserContext2 = _slicedToArray(_useUserContext, 1),
      _useUserContext2$0$cu = _useUserContext2[0].currentUser,
      customer_price_group = _useUserContext2$0$cu.customer_price_group,
      customer_flow_map_group = _useUserContext2$0$cu.customer_flow_map_group;

  var icon;

  switch (item === null || item === void 0 ? void 0 : (_item$file_format = item.file_format) === null || _item$file_format === void 0 ? void 0 : _item$file_format.toLowerCase()) {
    case 'cad':
    case '2d cad':
    case '3d cad':
      icon = React.createElement(CadIcon, null);
      break;

    case 'revit':
      icon = React.createElement(RevitIcon, null);
      break;

    case 'pdf':
      icon = React.createElement(PdfIcon, null);
      break;

    case 'image':
      icon = React.createElement(ImageFileIcon, null);
      break;

    default:
      icon = React.createElement(DocIcon, null);
  }

  var _useWindowSize = useWindowSize(),
      innerWidth = _useWindowSize.innerWidth;

  var isSmallDevice = innerWidth < 640;
  var isItemAllowedByPriceGroup = item.customer_price_group === 'General' ? true : (_item$customer_price_ = item.customer_price_group) === null || _item$customer_price_ === void 0 ? void 0 : _item$customer_price_.includes(customer_price_group ? customer_price_group : 'General');
  var isAllowedByCustomerGroup = useMemo(function () {
    var _item$customer_group;

    return (_item$customer_group = item.customer_group) === null || _item$customer_group === void 0 ? void 0 : _item$customer_group.includes(customer_flow_map_group ? customer_flow_map_group : 'Consumer');
  }, [customer_flow_map_group]);
  return React.createElement(React.Fragment, null, isItemAllowedByPriceGroup && isAllowedByCustomerGroup && React.createElement("div", {
    className: "col-span-9"
  }, React.createElement("div", {
    className: "grid grid-cols-9 sm_grid-cols-10 py-4 border-b border-solid border-snowbound items-center sm_py-3"
  }, React.createElement("div", {
    className: "col-span-12 sm_col-span-4 2xl_col-span-6 flex items-center"
  }, !isSmallDevice && icon, React.createElement("a", {
    href: item.url,
    target: "_blank",
    className: "pb-2 underline sm_no-underline sm_pb-0 sm_ml-2 text-bronze"
  }, item.file_name)), !isSmallDevice && React.createElement("div", {
    className: "col-span-1"
  }, React.createElement("div", {
    className: defaultClasses.hoverIcon
  }, React.createElement("a", {
    target: "_blank",
    href: item.url
  }, React.createElement("span", {
    className: "sr-only"
  }, "Download Resource"), React.createElement(DownloadResourceIcon, null)))), React.createElement("div", {
    className: "col-span-2 sm_col-span-2 2xl_col-span-1 flex items-center justify-center"
  }, React.createElement("div", {
    className: "sm_text-center text-bronze"
  }, item.file_size)), React.createElement("div", {
    className: "col-span-2 sm_col-span-1 sm_text-center text-bronze"
  }, item.file_format), React.createElement("div", {
    className: "col-start-10 col-span-4 text-right sm_col-span-2 2xl_col-span-1 sm_text-center text-bronze"
  }, item.date))));
};

export default ResourcesDocumentItem;